function isNullOrUndefined (obj: Record<string, unknown>) {
  return obj === undefined || obj === null
}

export default {
  defaultIfUndefinedOrNull (obj: Record<string, unknown>, defaultObj: Record<string, unknown> | null) {
    return isNullOrUndefined(obj) ? defaultObj : obj
  }
}
